// extracted by mini-css-extract-plugin
export default {"card":"Card_card__oso-+","header":"Card_header__OAXc0","title":"Card_title__6Ww0d","action":"Card_action__z7lQF","body":"Card_body__Kr6Rk","bodyFlush":"Card_bodyFlush__FG3hK"};